<template>
  <div>
    <v-row class="ma-0 my-4 align-center justify-space-between">
      <h1 class="text-h5 font-weight-bold">Brokers</h1>
    </v-row>

    <v-alert v-if="error" type="error" dense outlined dismissible class="mb-3">{{ error }}</v-alert>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <!-- Nuevo broker -->
          <v-card-text v-if="can('brokers:create')" class="pb-0">
            <v-row align="center" class="ma-0 gap-2">
              <v-text-field
                v-model="newNombre"
                label="Nombre"
                dense outlined hide-details
                class="mr-2"
                style="max-width: 200px"
                placeholder="Nombre del broker..."
                @keyup.enter="createBroker"
              />
              <v-text-field
                v-model="newRazonSocial"
                label="Razón social (opcional)"
                dense outlined hide-details
                class="mr-2"
                style="max-width: 220px"
                @keyup.enter="createBroker"
              />
              <v-btn color="primary" :loading="creating" :disabled="!newNombre.trim()" @click="createBroker">
                <v-icon left>mdi-plus</v-icon>Agregar
              </v-btn>
            </v-row>
          </v-card-text>

          <!-- Tabla -->
          <v-data-table
            :headers="headers"
            :items="brokers"
            :loading="loading"
            hide-default-footer
            :items-per-page="-1"
            class="elevation-0 mt-2"
            no-data-text="No hay brokers registrados"
          >
            <template v-slot:item.name="{ item }">
              <v-text-field
                v-if="editing === item.id"
                v-model="editData.name"
                dense outlined hide-details
                style="max-width: 200px"
              />
              <span v-else>{{ item.name }}</span>
            </template>

            <template v-slot:item.bussinesName="{ item }">
              <v-text-field
                v-if="editing === item.id"
                v-model="editData.bussinesName"
                dense outlined hide-details
                style="max-width: 220px"
              />
              <span v-else class="grey--text text--darken-1">{{ item.bussinesName || '—' }}</span>
            </template>

            <template v-slot:item.visible="{ item }">
              <v-chip x-small :color="item.visible ? 'success' : 'grey'" dark>
                {{ item.visible ? 'Activo' : 'Inactivo' }}
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <div v-if="editing === item.id" class="d-flex">
                <v-btn small color="primary" :loading="saving" @click="saveBroker(item)">
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
                <v-btn small text class="ml-1" @click="editing = null">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </div>
              <div v-else class="d-flex">
                <v-btn v-if="can('brokers:update')" icon small @click="startEdit(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-if="can('brokers:update')"
                  icon
                  small
                  class="ml-1"
                  @click="toggleVisible(item)"
                >
                  <v-icon small :color="item.visible ? 'grey' : 'success'">
                    {{ item.visible ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BrokerService from '../services/broker.service';
import { can } from '../utils/permissions';

export default {
  name: 'Brokers',
  data() {
    return {
      loading: false,
      creating: false,
      saving: false,
      error: null,
      brokers: [],
      newNombre: '',
      newRazonSocial: '',
      editing: null,
      editData: { name: '', bussinesName: '' },
      headers: [
        { text: 'Nombre',        value: 'name',         sortable: true },
        { text: 'Razón social',  value: 'bussinesName', sortable: false },
        { text: 'Estado',        value: 'visible',      sortable: false },
        { text: '',              value: 'actions',      sortable: false, align: 'end' },
      ],
    };
  },
  mounted() {
    this.loadBrokers();
  },
  methods: {
    can,
    async loadBrokers() {
      this.loading = true;
      const res = await BrokerService.getAll();
      if (res.status === 'ok') this.brokers = res.data;
      this.loading = false;
    },

    async createBroker() {
      if (!this.newNombre.trim()) return;
      this.creating = true;
      this.error = null;
      const res = await BrokerService.create({
        name: this.newNombre.trim(),
        bussinesName: this.newRazonSocial.trim() || null,
      });
      if (res.status === 'ok') {
        this.newNombre = '';
        this.newRazonSocial = '';
        await this.loadBrokers();
      } else {
        this.error = 'No se pudo crear el broker.';
      }
      this.creating = false;
    },

    startEdit(item) {
      this.editing = item.id;
      this.editData = { name: item.name, bussinesName: item.bussinesName || '' };
      this.error = null;
    },

    async saveBroker(item) {
      if (!this.editData.name.trim()) return;
      this.saving = true;
      this.error = null;
      const res = await BrokerService.update(item.id, {
        name: this.editData.name.trim(),
        bussinesName: this.editData.bussinesName.trim() || null,
      });
      if (res.status === 'ok') {
        item.name = this.editData.name.trim();
        item.bussinesName = this.editData.bussinesName.trim() || null;
        this.editing = null;
      } else {
        this.error = 'No se pudo actualizar el broker.';
      }
      this.saving = false;
    },

    async toggleVisible(item) {
      const res = await BrokerService.update(item.id, { visible: !item.visible });
      if (res.status === 'ok') item.visible = !item.visible;
    },
  },
};
</script>
